import { Profile }                from 'alto-react-client-auth/lib/components'
import CanteenChangePasswordPanel from './change_password_panel'

export default class CanteenProfile extends Profile
  @changePasswordPanelComponent: CanteenChangePasswordPanel

  enableFullProfile: ->
    super() and not @context.auth.isTerminal
